<template>
  <div class="main-row">  
    <div class="left-column">
      <div class="infobox no-border">
        <p>
          Din forventede lønn:<br> 
          <strong style="font-size: 2em;">{{ toMoney(user.expected_salary)}} kroner</strong><br><br>
          Dette er basert på {{user.years_in_it}} års erfaring som {{ user.field.toLowerCase() }}.
        </p>
        <p  class="display-on-mobile"> 
          Du ligger {{ toMoney(user.salary - user.expected_salary) }} kroner
          {{ (user.salary - user.expected_salary) > 0 ? "over" : "under" }} forventet lønn. Sjekk om det skyldes en av årsakene under:
        </p>
      </div>
      <p><a class="dashed-link display-off-mobile" @click="restart">TA KALKULATOREN PÅ NYTT</a></p>
    </div>

    <!-- Høyre kolonne -->
    <div class="right-column no-item-align">
      <div class="info-over-cards">
        <p  class="display-off-mobile"> 
          Du ligger {{ toMoney(user.salary - user.expected_salary) }} kroner
          {{ (user.salary - user.expected_salary) > 0 ? "over" : "under" }} forventet lønn. Sjekk om det skyldes en av årsakene under:
        </p>
      </div>

      <div class="card">
        <div class="card-icons">
          <v-icon large color="primary">business</v-icon>
          <v-icon v-if="user.county_adjusted > 0" large color="success">arrow_upward</v-icon>
          <v-icon v-else large color="error">arrow_downward</v-icon>
        </div>
        <p>IT-ansatte i {{ user.county }} tjener {{ toMoney(user.county_adjusted) }} kroner {{ user.county_adjusted > 0 ? "over" : "under" }} snittet i Norge</p>
      </div>

      <div class="card">
        <div class="card-icons">
          <v-icon large color="primary">school</v-icon>
          <v-icon v-if="user.education_adjusted > 0" large color="success">arrow_upward</v-icon>
          <v-icon v-else large color="error">arrow_downward</v-icon>
        </div>
        <p>IT-ansatte med ditt utdanningsnivå tjener {{ toMoney(user.education_adjusted) }} kroner {{ user.education_adjusted > 0 ? "over" : "under" }} snittet i Norge</p>
      </div>
      
      <div class="card">
        <div class="card-icons">
          <v-icon large color="primary">code</v-icon>
        </div>
        <p>
          <a class="dashed-link" href="https://www.digi.no/artikler/ferske-tall-sa-mye-tjener-norske-it-ansatte/430119?key=iTkqSqBl">Her er IT-fagfeltene som gir best betalt</a>
          <v-icon size="18px">chevron_right</v-icon>
        </p>
      </div>
      
      <div class="card">
        <div class="card-icons">
          <v-icon large color="primary">work</v-icon>
        </div>
        <p>
          <a class="dashed-link" href="https://www.digi.no/artikler/stor-oversikt-disse-sprakene-kan-de-best-betalte-utviklerne-i-norge/442408?key=oePuDuOI">Sjekk hvilke språk de best betalte utviklerne bruker</a> 
          <v-icon size="18px">chevron_right</v-icon>
        </p>
      </div>
      
      <v-btn style="width: 90%;" large color="primary" @click="restart" class="display-on-mobile">TA KALKULATOREN PÅ NYTT</v-btn>
    </div>
  </div>
</template>

<script>
export default {
    props: { 
      user: Object,
      user_default: Object,
      db: Object
    },
    methods: {
      restart() {
        this.db.collection('users').doc(this.user.user_id).delete().then(() => {
            console.log("Document successfully deleted!")
        }).catch(function(error) {
            console.error("Error removing document: ", error)
        })
      },
      toMoney: function(number) {
        if (number < 0) number = (0 - number)
        if (number > 9999) {
          number = number.toString()
          number = number.substring(0, number.length-3) + " " + number.substring(number.length-3)
        }
        return number
      }
    }
}
</script>

<style lang="scss">
.digi-kalk {
  .info-over-cards {
    width: 90%;
    padding: 30px 30px 10px 30px;
    margin-bottom: 20px;
    border-bottom: 2px dashed #107cb2;
  }
  .card {
    width: 90%;
    height: 100px;
    background-color: #fafafa;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-right: 15px;
  }
  .card p{
    margin: 0;
  }
  .card-icons {
    display: flex;
    flex-direction: column;
    padding: 0 20px 0 20px;
  }
}
.mobile{
  .info-over-cards {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Report.vue